import { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { ContaServico } from '../../../viewmodel/ContaServicoViewModel';
import ContaServicoViewModel from '../../../viewmodel/ContaServicoViewModel';

interface OptOutEmailModalProps {
    show: boolean;
    conta: ContaServico;
    onClose: () => void;
    onSuccess: (contaAtualizada: ContaServico) => void;
}

export default function OptOutEmailModal({ show, conta, onClose, onSuccess }: OptOutEmailModalProps) {
    const [receberEmail, setReceberEmail] = useState(!(conta.optOutEmailIntegracaoBancaAberta ?? false));
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleSalvar = async () => {
        try {
            setLoading(true);
            setError(null);
            const atualizada = await ContaServicoViewModel.atualizarOptOutEmail(conta.clientId, !receberEmail);
            onSuccess(atualizada);
            onClose();
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Erro ao salvar preferências');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Preferências de E-mail</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted mb-3">
                    <small>Conta: <strong>{conta.descricao}</strong></small>
                </p>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form.Check
                    type="switch"
                    id="opt-out-integracao"
                    label="Receber e-mails de abertura de integração (Banca Aberta)"
                    checked={receberEmail}
                    onChange={(e) => setReceberEmail(e.target.checked)}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Cancelar</Button>
                <Button variant="primary" onClick={handleSalvar} disabled={loading}>
                    {loading ? 'Salvando...' : 'Salvar'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
